import { collection, doc } from 'firebase/firestore';
import { ref, uploadBytes, deleteObject } from 'firebase/storage';
import { db, storage } from './firebase';
import { WorkspaceScope } from '../types/workspace';

export function getCollectionRef(scope: WorkspaceScope, name: string) {
  if (scope.mode !== 'admin' || !/^[A-Za-z0-9_-]+$/.test(scope.workspaceId)) throw new Error('Workspace 권한을 확인해주세요.');
  return collection(db, 'workspaces', scope.workspaceId, name);
}
export function getDocumentRef(scope: WorkspaceScope, name: string, id: string) {
  return doc(getCollectionRef(scope, name), id);
}
export async function uploadImage(scope: WorkspaceScope, file: File, folder: 'promotions' | 'system-settings'): Promise<string> {
  if (scope.mode !== 'admin') throw new Error('업로드 권한이 없습니다.');
  const extension = ({ 'image/png': 'png', 'image/jpeg': 'jpg', 'image/gif': 'gif', 'image/webp': 'webp' } as Record<string, string>)[file.type];
  if (!extension || file.size > 4 * 1024 * 1024) throw new Error('PNG/JPEG/GIF/WebP 4MB 이하 이미지를 사용해주세요.');
  const asset = `${folder}/${crypto.randomUUID()}.${extension}`;
  await uploadBytes(ref(storage, `workspaces/${scope.workspaceId}/${asset}`), file);
  return `${window.location.origin}/.netlify/functions/workspace-media?accountCode=${scope.accountCode}&asset=${encodeURIComponent(asset)}`;
}
export async function deleteImage(scope: WorkspaceScope, imageUrl: string): Promise<void> {
  const url = new URL(imageUrl);
  const asset = url.searchParams.get('asset') || '';
  if (scope.mode !== 'admin' || url.origin !== window.location.origin || url.searchParams.get('accountCode') !== scope.accountCode || !/^(promotions|system-settings)\/[A-Za-z0-9._-]+$/.test(asset)) throw new Error('삭제할 이미지의 Workspace를 확인해주세요.');
  await deleteObject(ref(storage, `workspaces/${scope.workspaceId}/${asset}`));
}
export function handleFirebaseError(error: unknown): string {
  if (error && typeof error === 'object' && 'code' in error && error.code === 'permission-denied') return '권한이 없습니다.';
  return error instanceof Error ? error.message : '요청을 처리할 수 없습니다.';
}
